import {
  UpdateGlossaryDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";
import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";

import { DOMAIN_GLOSSARY } from "../domain";

import { glossaryApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_UPDATE_GLOSSARY = "UPDATE_GLOSSARY";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

type UpdateGlossaryRequest = { id: string; data: UpdateGlossaryDto };

const updateGlossary = async (req: UpdateGlossaryRequest): Promise<void> => {
  await glossaryApi.glossaryControllerUpdateGlossaryTerm(req.id, req.data);
};

export const useUpdateGlossaryTerm = (
  user: UserProfileDto | null,
): {
  updateGlossary: UseMutateFunction<void, Error, UpdateGlossaryRequest, unknown>;
  updateGlossaryEnabled: boolean;
  isSuccessUpdateGlossary: boolean;
  isPendingUpdateGlossary: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_GLOSSARY, ACTION_UPDATE_GLOSSARY],
    mutationFn: enabled ? updateGlossary : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_GLOSSARY] });
    },
  });

  return {
    updateGlossary: mutate,
    updateGlossaryEnabled: enabled,
    isSuccessUpdateGlossary: isSuccess,
    isPendingUpdateGlossary: isPending,
  };
};
